import { HIDE_BUSY, SHOW_BUSY } from './busy-indicator-actions';

const defaultState = 0;

/**
 * BusyIndicator Reducer
 *
 * Consumes HIDE_BUSY action
 * Consumes SHOW_BUSY action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type
 * @returns {number} the new state
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
    case SHOW_BUSY:
        return state + 1;
    case HIDE_BUSY:
        return state > 0 ? state - 1 : 0;
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./components/busy-indicator/busy-indicator-reducer.js